// flow weak

import React, { Component } from "react";
import PropTypes from "prop-types";
import { AnimatedView, StatsCard, WorkProgress } from "../../../components";
import {
  redeem_voucher,
  getMerchantDeals,
  export_PurchaserList
} from "../../../redux/actions/voucherActions";
import { renderAlert, clearAlert } from "../../../redux/actions/alertsActions";
import { connect } from "react-redux";
import {
  Row,
  Col,
  Button,
  FormGroup,
  FormControl,
  ControlLabel,
  Alert,
  Image
} from "react-bootstrap";
import { withRouter } from "react-router";
import { bindActionCreators, compose } from "redux";
import { createBrowserHistory } from "history";
import loader from "../../../style/loader/loader.scss";
import Dialog from "react-bootstrap-dialog";
import ReactAutocomplete from "react-autocomplete";
import MerchantPayout from "./MerchantPayout";
import DealList from "../../admin/deal/DealList";
import auth from "../../../services/auth";
import { Link } from "react-router-dom";
import { getLogo }    from '../../../redux/actions/designCenterActions';
import siteLogo from "../../../img/ddb-logo.png";
import moment from 'moment';

let dataSet1 = [];
const history = createBrowserHistory();

let isLoading = "false",
  headers = [],
  data1 = [],
  userID = "";
class Dashboard extends Component {
  static contextTypes = {
    router: PropTypes.object
  }
  constructor(props) {
    super(props);
    this.state = {
      dealID: "",
      deallist: [],
      dealIDs: [],
      show: false,
      alertMessage: "",
      voucherData: "",
      voucher: "",
      filename: "",
      exportdata: [],
      note: "",
      merchantinfo:"",
      merchantID: "",
      themeData: {},
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleDismiss = this.handleDismiss.bind(this);
    this.handleShow = this.handleShow.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.validate = this.validate.bind(this);
  }

  handleDismiss() {
    this.setState({ show: false });
  }

  handleShow() {
    this.setState({ show: true });
  }

  componentWillMount() {
    this.handleDismiss();
    this.props.clearAlert();
    isLoading = "true";

    userID = this.props.match.params.user_id
      ? this.props.match.params.user_id
      : "";
    if (userID !== "") {
      this.props.getMerchantDeals(userID);
    } else {
      const userinfo = auth.getUserInfo();
      if (userinfo.user_id !== "") {
        this.props.getMerchantDeals(userinfo.user_id);
      }
    }
    let siteData = JSON.parse(localStorage.getItem('siteDDBStatus'));
    let defaultCity;
    if(siteData){
      if(siteData.default_city){
        defaultCity = siteData.default_city;
      }
    }

    this.props.getLogo({scheduledDate:moment().format("YYYY-MM-DD HH:mm:ss"), cityID: defaultCity});
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.merchantdealList !== nextProps.merchantdealList) {
      if (nextProps.merchantdealList) {
        isLoading = "false";
        this.setState({ deallist: nextProps.merchantdealList.data.data });
        let merchant=  nextProps.merchantdealList.merchantInfo? nextProps.merchantdealList.merchantInfo:{} ;
        
        this.setState({ merchantname:merchant.legalName, address1: merchant.address1, address2: merchant.address2, city: merchant.city, state: merchant.state, country: merchant.country, zipcode:merchant.zipcode, email:merchant.email, phone:merchant.phone, merchantID: merchant.merchant_id, user_id: merchant.user_id});
      }
    }

    if (this.props.exportList !== nextProps.exportList) {
      if (nextProps.exportList) {
        isLoading = "false";
        this.setState({ exportdata: nextProps.exportList.data });
      }
    }

    if (this.props.redeemvoucher !== nextProps.redeemvoucher) {
      if (nextProps.redeem_voucher) {
        isLoading = "false";
        this.props.clearAlert();
        this.handleShow();
        this.setState({
          alertMessage: nextProps.redeemvoucher.message,
          msgType: "success"
        });
        // this.props.renderAlert("success", nextProps.redeemvoucher.message);
        this.state.voucher = "";
        this.state.note = "";

        this.setState({ voucherData: nextProps.redeemvoucher.data });
        window.scrollTo(0, 0);
      }
    }

    if (nextProps.message) {
      this.handleShow();
      this.setState({
        alertMessage: nextProps.message,
        msgType: nextProps.alertType
      });
      window.scrollTo(0, 0);
      isLoading = "false";
    }

    if (this.props.error !== nextProps.error) {
      if (nextProps.error) {
        isLoading = "false";
        this.props.clearAlert();
        this.setState({
          alertMessage: nextProps.error,
          msgType: "warning"
        });
        // this.props.renderAlert("warning", nextProps.error);
        this.state.voucher = "";
        this.state.note = "";
      }
    }
    if(this.props.themeData !== nextProps.themeData){
      if(nextProps.themeData){
        this.setState({themeData: nextProps.themeData.data.logo});
      }
    }

  }

  handleChange(e) {
    if (`${e.target.name}Error` !== "") {
      this.setState({ [`${e.target.name}Error`]: "" });
    }
    this.setState({ [e.target.name]: e.target.value });
  }

  handleListChangeOnDeal(e) {
    if (`${e.target.name}Error` !== "") {
      this.setState({ [`${e.target.name}Error`]: "" });
    }

    let options = e.target.options;
    var value = [];
    for (var i = 0, l = options.length; i < l; i++) {
      if (options[i].selected) {
        value.push(options[i].value);
      }
    }
    this.setState({ dealIDs: value });
    this.setState({ disabled: false });
  }

  handleVoucher = () => {
    this.handleDismiss();
    if (!this.state.voucher) {
      this.setState({ voucherError: "red" });
    } else {
      this.dialog.show({
        body: "Are you sure you want to redeem this voucher?",
        actions: [
          Dialog.CancelAction(),
          Dialog.OKAction(() => {
            this.confirmRedeem();
          })
        ]
      });
    }
  };

  validate = () => {
    let isError = false;
    const errors = {};

    if (this.state.dealIDs.length === 0) {
      isError = true;
      this.setState({ dealIDsError: "red" });
    }
    return isError;
  };

  handleSubmit(e) {
    e.preventDefault();
    const err = this.validate();

    if (!err) {
      const postData = {
        dealID: this.state.dealIDs,
        fileName: this.state.filename
      };
      this.props.export_PurchaserList(postData);
    }
  }

  confirmRedeem() {
    const postdata = {
      voucherNumber: this.state.voucher,
      note: this.state.note,
    };
    this.props.redeem_voucher(postdata);
    isLoading = "true";
    this.handleShow();
  }
  handleClose = () => {
    this.handleDismiss();
    this.state.voucherData = "";
  };

  displayLogo() {
    if (this.state.themeData) {
      return this.state.themeData;
    } else {
      return siteLogo;
    }
  }

  render() {
    dataSet1 = this.state.exportdata;
    
    let dealListItems = [];
    let dealListData = this.state.deallist ? this.state.deallist : "";
    if (dealListData !== "") {
      dealListItems = dealListData.map((el, key) => (
        <option key={key} value={el.dealID}>
          {el.dealText}
        </option>
      ));
    }
    let voucher = this.state.voucherData ? this.state.voucherData : {};
    if (!this.state.voucherData) {
      isLoading = "false";
    }
    this.state.voucherData !== ""
      ? $("#voucherdiv *").prop("visible", true)
      : $("#voucherdiv *").prop("visible", false);

    headers = [
      { label: "Voucher Number", key: "voucherNumber" },
      { label: "Tracking Number", key: "trackingNumber" }
    ];

    data1 = this.state.exportdata;

    return (
      <AnimatedView>
        <Dialog
          ref={el => {
            this.dialog = el;
          }}
        />
        {isLoading == "true" ? (
          <div className="loader">
            <p className="loading-message">
              <i>Loading...</i>
            </p>
            <div className="spinner">
              <div className="dot1" />
              <div className="dot2" />
            </div>
          </div>
        ) : (
          ""
        )}
        <Col lg={12} md={12} sm={12}>
          <div className="Co-logo">
            <Image src={this.displayLogo()} />
          </div>
        </Col>
        {this.state.show &&
          this.state.alertMessage !== "" && (
            <div className="col-lg-12">
              <Alert
                bsStyle={this.state.msgType}
                onDismiss={this.handleDismiss}
              >
                <strong>{this.state.msgType}:</strong>{" "}
                {this.state.alertMessage}
              </Alert>
            </div>
          )}
        <div className="col-lg-12 add-sub-admin">
          <div className="panel">
          <header className="panel-heading">{this.state.merchantname}</header>
            <div className="panel-body">
              <div className="add-city col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <Row>
                  {(this.state.address1) &&
                  <Col md={12} xs={12} style={{ lineHeight: '30px'}}>
                    <b>{this.state.address1}</b>
                  </Col>
                  }
                  {(this.state.address2) &&
                  <Col md={12} xs={12} style={{ lineHeight: '30px'}}>
                   <b>{this.state.address2}</b>
                  </Col>
                  }
                  {this.state.country &&
                  <Col md={12} xs={12} style={{ lineHeight: '30px'}}>
                    <b> {this.state.city}, {this.state.state}, {this.state.country}, {this.state.zipcode} </b>
                  </Col>
                  }
                  {this.state.email &&
                  <Col md={12} xs={12} style={{ lineHeight: '30px'}}>
                    <b>Contact Email : {this.state.email}</b>
                  </Col>
                  }
                  {this.state.phone &&
                  <Col md={12} xs={12} style={{ lineHeight: '30px'}}>
                    <b>Contact Phone : {this.state.phone}</b>
                  </Col>
                  }
                </Row>
              </div>
            </div>
          </div>
        </div>

        <div className="col-lg-12 add-sub-admin">
          <div className="panel">
          <header className="panel-heading">Redeem Vouchers</header>
            <div className="panel-body">
              <div className="add-city col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <Row>
                  <Col md={6} xs={12}>
                    <FormControl
                      className="halfWidth"
                      type="text"
                      value={this.state.voucher}
                      placeholder="Enter Voucher Number"
                      onChange={this.handleChange}
                      name="voucher"
                      style={{ borderColor: this.state.voucherError }}
                    />
                  </Col>
                  <Col md={6} xs={12}>
                    <FormControl
                      className="halfWidth"
                      type="text"
                      value={this.state.note}
                      placeholder="Enter Note"
                      onChange={this.handleChange}
                      name="note"
                      style={{ borderColor: this.state.noteError }}
                    />
                  </Col>
                </Row>
                <br />
                <Row>
                  <Col md={12} xs={12}>
                    <Button
                      bsStyle="info"
                      type="submit"
                      onClick={this.handleVoucher.bind(this)}
                    >
                      Redeem{" "}
                    </Button>

                  </Col>
                </Row>
              </div>
            </div>
          </div>

          {this.state.voucherData ? (
            <div className="panel">
              <header className="panel-heading">Voucher Detail </header>
              <div className="col-lg-12 text-right">
                <Button bsStyle="info" onClick={this.handleClose.bind(this)}>
                  X
                </Button>
              </div>
              <div className="panel-body">
                <div className="add-city col-lg-12 col-md-12 col-sm-12 col-xs-12">
                  <Row>
                    <Col md={6} xs={12}>
                      <FormGroup controlId="formBasic1">
                        <ControlLabel>Voucher Number :</ControlLabel>
                      </FormGroup>
                      <FormGroup controlId="formBasic2">
                        <ControlLabel>Voucher Type :</ControlLabel>
                      </FormGroup>
                      <FormGroup controlId="formBasic3">
                        <ControlLabel>Quantity :</ControlLabel>
                      </FormGroup>
                      <FormGroup controlId="formBasic4">
                        <ControlLabel>Voucher Value :</ControlLabel>
                      </FormGroup>
                      <FormGroup controlId="formBasic5">
                        <ControlLabel>Offer :</ControlLabel>
                      </FormGroup>
                      <FormGroup controlId="formBasic6">
                        <ControlLabel>Status :</ControlLabel>
                      </FormGroup>
                      <FormGroup controlId="formBasic7">
                        <ControlLabel>Expiry Date :</ControlLabel>
                      </FormGroup>
                    </Col>
                    <Col md={6} xs={12}>
                      <FormGroup controlId="formBasic8">
                        <ControlLabel>{voucher.voucherNumber} </ControlLabel>
                      </FormGroup>
                      <FormGroup controlId="formBasic9">
                        <ControlLabel>{voucher.voucherType}</ControlLabel>
                      </FormGroup>
                      <FormGroup controlId="formBasic10">
                        <ControlLabel>{voucher.quantity}</ControlLabel>
                      </FormGroup>
                      <FormGroup controlId="formBasic11">
                        <ControlLabel> {voucher.voucherValue} </ControlLabel>
                      </FormGroup>
                      <FormGroup controlId="formBasic12">
                        <ControlLabel>{voucher.dealText}</ControlLabel>
                      </FormGroup>
                      <FormGroup controlId="formBasic13">
                        <ControlLabel> {voucher.status}</ControlLabel>
                      </FormGroup>
                      <FormGroup controlId="formBasic14">
                        <ControlLabel>{voucher.expiryDate}</ControlLabel>
                      </FormGroup>
                    </Col>
                  </Row>
                </div>
              </div>
            </div>
          ) : (
            ""
          )}

          {userID !== "" && this.state.deallist.length !== 0 ? (
            <div className="panel">
              <div className="panel-body">
                <div className="col-md-12">
                  <Row>
                    <Col>
                      <Button
                        bsSize="small"
                        bsStyle="success"
                        onClick={() => this.context.router.history.push(`/contract/view/${userID}`)}
                      >
                        View Contract
                      </Button>
                      <Button
                        bsSize="small"
                        bsStyle="success"
                        onClick={() =>
                          this.context.router.history.push(`/merchant/voucher/list/${userID}`)
                        }
                      >
                        Voucher List & Print
                      </Button>
                      <Button
                        bsSize="small"
                        bsStyle="success"
                        onClick={() =>
                          this.context.router.history.push(`/trackingnumbers/List/${userID}`)
                        }
                      >
                        Upload Tracking Numbers
                      </Button>
                    </Col>
                  </Row>
                </div>
              </div>
            </div>
          ) : (
            ""
          )}

          {this.state.merchantID &&
          <DealList key={this.state.merchantID} merchantID={(this.state.merchantID) ? this.state.merchantID : ""} />
          }
        </div>
      </AnimatedView>
    );
  }
}

const mapStateToProps = state => ({
  merchantdealList: state.voucherReducer.merchantdealList,
  redeemvoucher: state.voucherReducer.redeemvoucher,
  error: state.voucherReducer.error,
  alertType: state.alertsReducer.alertType,
  message: state.alertsReducer.message,
  exportList: state.voucherReducer.exportList,
  themeData:  state.designCenterReducer.themeData
});

export default compose(
  withRouter, // IMPORTANT: witRouter is "needed here" to avoid blocking routing:
  connect(mapStateToProps, {
    redeem_voucher,
    renderAlert,
    clearAlert,
    getMerchantDeals,
    export_PurchaserList,
    getLogo
  })
)(Dashboard);



// WEBPACK FOOTER //
// ./src/app/views/merchant/dashboard/Dashboard.js